import SplashGame from "@/lib/SplashGame";
import { GAME_EVENT } from "@/lib/SplashGame/EventHandler";
import { NotificationType } from "@/types/Notification";
var BotController = /** @class */ (function () {
    function BotController(bot, enemies, algorithms) {
        this.tick = 0;
        this.bot = bot;
        this.enemies = enemies;
        this.algorithms = algorithms;
        this.enemy = null;
        this.init();
    }
    BotController.prototype.init = function () {
        var _this = this;
        var eventHandler = SplashGame.EventHandler.getInstance();
        eventHandler.on([GAME_EVENT.NOTIFICATION, NotificationType.DEATH].join("-"), function (e) {
            if (!_this.enemy)
                return;
            var detail = e.detail.detail;
            if (!detail)
                return;
            var id = detail.id, is_alive = detail.is_alive;
            if (is_alive)
                return;
            var user = _this.enemy.getValue();
            if (id !== user.id)
                return;
            _this.enemy = null;
            _this.random_bot_movement();
        });
    };
    BotController.prototype.random_bot_movement = function () {
        var radian = Phaser.Math.RND.rotation();
        this.bot.rotate(radian);
    };
    BotController.prototype.release = function () {
        this.enemy = null;
        this.random_bot_movement();
    };
    BotController.prototype.update = function () {
        var _a;
        if (!this.bot.getValue().game.is_alive)
            return;
        if (this.tick % 300 === 0) {
            this.enemy = this.algorithms.chase.func(this.bot, this.enemies, this.algorithms.chase.breakpoint, this.enemy);
        }
        if (!((_a = this.enemy) === null || _a === void 0 ? void 0 : _a.getValue().game.is_alive)) {
            this.enemy = null;
        }
        if (this.enemy) {
            var radian = Math.atan2(this.enemy.y - this.bot.y, this.enemy.x - this.bot.x);
            this.bot.rotate(radian - Math.PI / 2);
            if (this.tick % 60 === 0) {
                this.algorithms.attack.func(this.bot, this.enemy, this.algorithms.attack.breakpoint);
            }
        }
        else {
            if (this.tick % 60 === 0) {
                this.random_bot_movement();
            }
        }
        this.tick++;
        this.tick %= 600;
    };
    return BotController;
}());
export default BotController;
